import React from 'react';
import '../LegalPages.css';
import Footer from '../../../components/layout/Footer/Footer';
import Header from '../../../components/layout/Header/Header';
import { Link } from 'react-router-dom';

const CookiesPolicy = () => {
  return (
    <div className="legal-page">
      <div className="classjustforheadercolor"></div>
      <Header />
      
      {/* Hero Section */}
      <section className="legal-hero">
        <div className="container">
          <div className="legal-hero__content">
            <div className="hero-badge">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="12" cy="12" r="10"/>
                <path d="M12 16v-4M12 8h.01"/>
              </svg>
              <span>Politique de Cookies</span>
            </div>
            
            <h1 className="legal-hero__title">
              Comprendre l'Utilisation des <span className="title-highlight">Cookies</span>
            </h1>
            
            <p className="legal-hero__subtitle">
              Transparence totale sur la façon dont nous utilisons les cookies pour améliorer votre expérience.
            </p>
            
            <div className="legal-meta">
              <div className="legal-meta__item">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <circle cx="12" cy="12" r="10"/>
                  <path d="M12 6v6l4 2"/>
                </svg>
                <span>Dernière mise à jour : 18 Novembre 2025</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="legal-content">
        <div className="container">
          <div className="legal-grid">
            {/* Main Content */}
            <div className="legal-main">
              <div className="legal-section">
                <h2 className="legal-section__title">1. Qu'est-ce qu'un Cookie?</h2>
                <p className="legal-section__text">
                  Un cookie est un petit fichier texte stocké sur votre appareil (ordinateur, 
                  smartphone, tablette) lorsque vous visitez un site web. Les cookies permettent 
                  au site de mémoriser vos actions et préférences pendant une période donnée.
                </p>
                <p className="legal-section__text">
                  Ces fichiers contiennent des informations relatives à votre navigation et nous 
                  aident à améliorer votre expérience sur notre site.
                </p>
              </div>

              <div className="legal-section">
                <h2 className="legal-section__title">2. Types de Cookies Utilisés</h2>
                
                <div className="cookie-types">
                  <div className="cookie-type-card">
                    <div className="cookie-type-card__header">
                      <div className="cookie-type-card__icon cookie-type-card__icon--essential">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
                        </svg>
                      </div>
                      <h3 className="cookie-type-card__title">Cookies Essentiels</h3>
                      <span className="cookie-type-card__badge cookie-type-card__badge--required">Obligatoires</span>
                    </div>
                    <p className="cookie-type-card__text">
                      Ces cookies sont indispensables au fonctionnement du site. Ils vous permettent 
                      de naviguer et d'utiliser les fonctionnalités de base.
                    </p>
                    <ul className="cookie-type-card__list">
                      <li>Gestion du panier d'achat</li>
                      <li>Mémorisation de la session</li>
                      <li>Sécurité et authentification</li>
                      <li>Préférences linguistiques</li>
                    </ul>
                    <p className="cookie-type-card__duration">
                      <strong>Durée :</strong> Session ou 1 an
                    </p>
                  </div>

                  <div className="cookie-type-card">
                    <div className="cookie-type-card__header">
                      <div className="cookie-type-card__icon cookie-type-card__icon--functional">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                          <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"/>
                        </svg>
                      </div>
                      <h3 className="cookie-type-card__title">Cookies Fonctionnels</h3>
                      <span className="cookie-type-card__badge">Optionnels</span>
                    </div>
                    <p className="cookie-type-card__text">
                      Ces cookies améliorent votre expérience en mémorisant vos choix et préférences.
                    </p>
                    <ul className="cookie-type-card__list">
                      <li>Thème préféré (clair/sombre)</li>
                      <li>Langue sélectionnée</li>
                      <li>Produits récemment consultés</li>
                      <li>Liste de souhaits</li>
                    </ul>
                    <p className="cookie-type-card__duration">
                      <strong>Durée :</strong> 1 an
                    </p>
                  </div>

                  <div className="cookie-type-card">
                    <div className="cookie-type-card__header">
                      <div className="cookie-type-card__icon cookie-type-card__icon--analytics">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                          <line x1="12" y1="20" x2="12" y2="10"/>
                          <line x1="18" y1="20" x2="18" y2="4"/>
                          <line x1="6" y1="20" x2="6" y2="16"/>
                        </svg>
                      </div>
                      <h3 className="cookie-type-card__title">Cookies Analytiques</h3>
                      <span className="cookie-type-card__badge">Optionnels</span>
                    </div>
                    <p className="cookie-type-card__text">
                      Ces cookies nous aident à comprendre comment les visiteurs utilisent notre site.
                    </p>
                    <ul className="cookie-type-card__list">
                      <li>Nombre de visiteurs</li>
                      <li>Pages les plus visitées</li>
                      <li>Durée de visite</li>
                      <li>Sources de trafic</li>
                    </ul>
                    <p className="cookie-type-card__duration">
                      <strong>Durée :</strong> 2 ans
                    </p>
                  </div>

                  <div className="cookie-type-card">
                    <div className="cookie-type-card__header">
                      <div className="cookie-type-card__icon cookie-type-card__icon--marketing">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                          <path d="M22 12h-4l-3 9L9 3l-3 9H2"/>
                        </svg>
                      </div>
                      <h3 className="cookie-type-card__title">Cookies Marketing</h3>
                      <span className="cookie-type-card__badge">Optionnels</span>
                    </div>
                    <p className="cookie-type-card__text">
                      Ces cookies sont utilisés pour vous proposer des publicités pertinentes.
                    </p>
                    <ul className="cookie-type-card__list">
                      <li>Publicités personnalisées</li>
                      <li>Mesure de l'efficacité des campagnes</li>
                      <li>Retargeting</li>
                      <li>Partage sur réseaux sociaux</li>
                    </ul>
                    <p className="cookie-type-card__duration">
                      <strong>Durée :</strong> Variable (jusqu'à 2 ans)
                    </p>
                  </div>
                </div>
              </div>

              <div className="legal-section">
                <h2 className="legal-section__title">3. Cookies Tiers</h2>
                <p className="legal-section__text">
                  Certains cookies sont placés par des services tiers que nous utilisons :
                </p>
                
                <div className="legal-subsection">
                  <h3 className="legal-subsection__title">3.1 Google Analytics</h3>
                  <p className="legal-section__text">
                    Pour analyser l'utilisation de notre site et améliorer nos services.
                  </p>
                </div>

                <div className="legal-subsection">
                  <h3 className="legal-subsection__title">3.2 Réseaux Sociaux</h3>
                  <p className="legal-section__text">
                    Les boutons de partage peuvent déposer des cookies (Facebook, Instagram, LinkedIn).
                  </p>
                </div>

                <div className="legal-subsection">
                  <h3 className="legal-subsection__title">3.3 Cloudinary</h3>
                  <p className="legal-section__text">
                    Pour l'optimisation et la livraison des images sur notre site.
                  </p>
                </div>
              </div>

              <div className="legal-section">
                <h2 className="legal-section__title">4. Gestion de Vos Préférences</h2>
                <p className="legal-section__text">
                  Vous avez le contrôle total sur l'utilisation des cookies :
                </p>

                <div className="cookie-control-section">
                  <div className="cookie-control-card">
                    <div className="cookie-control-card__icon">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <circle cx="12" cy="12" r="3"/>
                        <path d="M12 1v6m0 6v6M5.6 5.6l4.2 4.2m4.2 4.2l4.2 4.2M1 12h6m6 0h6M5.6 18.4l4.2-4.2m4.2-4.2l4.2-4.2"/>
                      </svg>
                    </div>
                    <h3 className="cookie-control-card__title">Via Notre Bandeau</h3>
                    <p className="cookie-control-card__text">
                      Lors de votre première visite, un bandeau vous permet de choisir les cookies 
                      que vous acceptez.
                    </p>
                  </div>

                  <div className="cookie-control-card">
                    <div className="cookie-control-card__icon">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <circle cx="12" cy="12" r="10"/>
                        <line x1="12" y1="8" x2="12" y2="12"/>
                        <line x1="12" y1="16" x2="12.01" y2="16"/>
                      </svg>
                    </div>
                    <h3 className="cookie-control-card__title">Via Votre Navigateur</h3>
                    <p className="cookie-control-card__text">
                      Vous pouvez configurer votre navigateur pour bloquer ou supprimer les cookies.
                    </p>
                  </div>

                  <div className="cookie-control-card">
                    <div className="cookie-control-card__icon">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <polyline points="9 11 12 14 22 4"/>
                        <path d="M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11"/>
                      </svg>
                    </div>
                    <h3 className="cookie-control-card__title">Modifier Vos Choix</h3>
                    <p className="cookie-control-card__text">
                      Vous pouvez modifier vos préférences à tout moment en cliquant sur le lien 
                      en bas de page.
                    </p>
                  </div>
                </div>
              </div>

              <div className="legal-section">
                <h2 className="legal-section__title">5. Configuration par Navigateur</h2>
                <p className="legal-section__text">
                  Voici comment gérer les cookies selon votre navigateur :
                </p>

                <div className="browser-guides">
                  <details className="browser-guide">
                    <summary className="browser-guide__title">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <circle cx="12" cy="12" r="10"/>
                      </svg>
                      Google Chrome
                    </summary>
                    <div className="browser-guide__content">
                      <ol className="legal-list">
                        <li>Cliquez sur le menu (trois points verticaux)</li>
                        <li>Sélectionnez "Paramètres"</li>
                        <li>Cliquez sur "Confidentialité et sécurité"</li>
                        <li>Sélectionnez "Cookies et autres données de sites"</li>
                        <li>Choisissez vos préférences</li>
                      </ol>
                    </div>
                  </details>

                  <details className="browser-guide">
                    <summary className="browser-guide__title">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <circle cx="12" cy="12" r="10"/>
                      </svg>
                      Mozilla Firefox
                    </summary>
                    <div className="browser-guide__content">
                      <ol className="legal-list">
                        <li>Cliquez sur le menu (trois lignes horizontales)</li>
                        <li>Sélectionnez "Paramètres"</li>
                        <li>Cliquez sur "Vie privée et sécurité"</li>
                        <li>Sous "Cookies et données de sites", gérez vos préférences</li>
                      </ol>
                    </div>
                  </details>

                  <details className="browser-guide">
                    <summary className="browser-guide__title">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <circle cx="12" cy="12" r="10"/>
                      </svg>
                      Safari
                    </summary>
                    <div className="browser-guide__content">
                      <ol className="legal-list">
                        <li>Cliquez sur "Safari" dans la barre de menu</li>
                        <li>Sélectionnez "Préférences"</li>
                        <li>Cliquez sur l'onglet "Confidentialité"</li>
                        <li>Gérez les cookies et données de sites web</li>
                      </ol>
                    </div>
                  </details>

                  <details className="browser-guide">
                    <summary className="browser-guide__title">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <circle cx="12" cy="12" r="10"/>
                      </svg>
                      Microsoft Edge
                    </summary>
                    <div className="browser-guide__content">
                      <ol className="legal-list">
                        <li>Cliquez sur le menu (trois points horizontaux)</li>
                        <li>Sélectionnez "Paramètres"</li>
                        <li>Cliquez sur "Cookies et autorisations de site"</li>
                        <li>Gérez vos préférences de cookies</li>
                      </ol>
                    </div>
                  </details>
                </div>
              </div>

              <div className="legal-section">
                <h2 className="legal-section__title">6. Conséquences du Refus</h2>
                <p className="legal-section__text">
                  Si vous bloquez tous les cookies :
                </p>
                <ul className="legal-list">
                  <li>Certaines fonctionnalités du site peuvent ne pas fonctionner correctement</li>
                  <li>Votre panier d'achat ne sera pas sauvegardé</li>
                  <li>Vos préférences (langue, thème) ne seront pas mémorisées</li>
                  <li>Vous devrez vous reconnecter à chaque visite</li>
                </ul>
                <p className="legal-section__text">
                  Les cookies essentiels ne peuvent pas être désactivés car ils sont nécessaires 
                  au fonctionnement du site.
                </p>
              </div>

              <div className="legal-section">
                <h2 className="legal-section__title">7. Durée de Conservation</h2>
                <div className="legal-table-wrapper">
                  <table className="legal-table">
                    <thead>
                      <tr>
                        <th>Type de Cookie</th>
                        <th>Durée de Conservation</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Cookies de session</td>
                        <td>Jusqu'à la fermeture du navigateur</td>
                      </tr>
                      <tr>
                        <td>Cookies essentiels</td>
                        <td>1 an maximum</td>
                      </tr>
                      <tr>
                        <td>Cookies fonctionnels</td>
                        <td>1 an</td>
                      </tr>
                      <tr>
                        <td>Cookies analytiques</td>
                        <td>2 ans</td>
                      </tr>
                      <tr>
                        <td>Cookies marketing</td>
                        <td>Variable (jusqu'à 2 ans)</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div className="legal-section">
                <h2 className="legal-section__title">8. Mises à Jour</h2>
                <p className="legal-section__text">
                  Cette politique peut être mise à jour pour refléter les changements dans nos 
                  pratiques ou pour d'autres raisons opérationnelles, légales ou réglementaires.
                </p>
              </div>

              <div className="legal-section">
                <h2 className="legal-section__title">9. Contact</h2>
                <p className="legal-section__text">
                  Pour toute question concernant notre utilisation des cookies :
                </p>
                <div className="legal-contact-info">
                  <p><strong>Email :</strong> cookies@burotime.dz</p>
                  <p><strong>Téléphone :</strong> +213 560 60 56 55</p>
                  <p><strong>Téléphone2:</strong> +213 560 39 42 54</p>
               </div>
              </div>
            </div>

            {/* Sidebar */}
            <aside className="legal-sidebar">
              <div className="legal-sidebar__card">
                <h3 className="legal-sidebar__title">Navigation Rapide</h3>
                <nav className="legal-sidebar__nav">
                  <a href="#" className="legal-sidebar__link">Qu'est-ce qu'un cookie?</a>
                  <a href="#" className="legal-sidebar__link">Types de cookies</a>
                  <a href="#" className="legal-sidebar__link">Cookies tiers</a>
                  <a href="#" className="legal-sidebar__link">Vos préférences</a>
                  <a href="#" className="legal-sidebar__link">Configuration</a>
                  <a href="#" className="legal-sidebar__link">Contact</a>
                </nav>
              </div>

              <div className="legal-sidebar__card">
                <h3 className="legal-sidebar__title">Documents Connexes</h3>
                <div className="legal-sidebar__links">
                  <Link to="/privacy" className="legal-sidebar__doc-link">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
                    </svg>
                    Politique de Confidentialité
                  </Link>
                  <Link to="/terms" className="legal-sidebar__doc-link">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/>
                      <polyline points="14 2 14 8 20 8"/>
                    </svg>
                    Conditions Générales
                  </Link>
                  <Link to="/faq" className="legal-sidebar__doc-link">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <circle cx="12" cy="12" r="10"/>
                      <path d="M9.09 9a3 3 0 015.83 1c0 2-3 3-3 3"/>
                      <line x1="12" y1="17" x2="12.01" y2="17"/>
                    </svg>
                    Questions Fréquentes
                  </Link>
                </div>
              </div>

              <div className="legal-sidebar__card legal-sidebar__card--highlight">
                <div className="legal-sidebar__icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <circle cx="12" cy="12" r="3"/>
                    <path d="M12 1v6m0 6v6M5.6 5.6l4.2 4.2m4.2 4.2l4.2 4.2M1 12h6m6 0h6M5.6 18.4l4.2-4.2m4.2-4.2l4.2-4.2"/>
                  </svg>
                </div>
                <h3 className="legal-sidebar__title">Gérer les Cookies</h3>
                <p className="legal-sidebar__text">
                  Configurez vos préférences de cookies à tout moment.
                </p>
                <button className="legal-sidebar__btn" onClick={() => alert('Panneau de gestion des cookies')}>
                  Mes Préférences
                  <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                  </svg>
                </button>
              </div>
            </aside>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default CookiesPolicy;